module.exports = __webpack_public_path__ + "img/logo_selectra.88c14548.svg";